<footer class="ups-footer">
    <div class="top-section">
        <div class="column" *ngFor="let column of columns; let i = index">
            <h3 (click)="toggleColumn(i)"> 
                {{ column.title}}
                <mat-icon *ngIf="isMobileView"> {{ column.isExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
            </h3>
        <ul *ngIf="!isMobileView || column.isExpanded">
            <li *ngFor="let link of column.links">
                
                <a *ngIf="link.route; else externalLink" [routerLink]="link.route">
                    <span class="link-text"> 
                        {{ link.text }} 
                        <img *ngIf="link.svg" [src]="link.svg" alt="Icon" class="link-icon">
                    </span>
                </a>

                <ng-template #externalLink>
                    <a [href]="link.href" target="_blank" rel="noopener noreferrer" class="link-container">
                        <span class="text" [innerHTML]="link.text"></span>
                        <img *ngIf="link.svg" [src]="link.svg" alt="External Link" class="link-icon">
                    </a>
                </ng-template>

            </li>
        </ul>
        </div>
    </div>

    <div class="bottom-section"> 
        <!-- CRITICAL FIX: Replace static legal links with dynamic loop -->
        <div class="legal-links">
            <ul>
                <li *ngFor="let link of bottomLegalLinks">
                    <a [href]="link.href" [target]="link.target || '_self'" [attr.rel]="link.target === '_blank' ? 'noopener noreferrer' : null">
                        {{ link.text }} 
                        <img *ngIf="link.svg" [src]="link.svg">
                    </a>
                </li>
            </ul>
        </div>

        <div class="copyright-section">
            <p>Copyright ©1994 - 2025 United Parcel Service of America, Inc. All rights reserved.</p>
        </div>
    </div>
</footer>